<phx-dialog
  [phxWidth]="isMobileView ? '100vw' : 600"
  [phxOpen]="phxOpen"
  [phxBackdrop]="true"
  [phxPlacement]="'center'"
  (phxOpenChange)="phxOpenChange.emit($event)"
  (phxBackdropClicked)="onBackdropClicked()"
  (phxKeydown)="onKeydown($event)"
>
  <div class="phx-modal-upsell">

    <div class="phx-modal-upsell-body">

      <!-- Shared header — always rendered so ng-content slots are only claimed once -->
      <div class="phx-modal-upsell-header" [class.phx-modal-upsell-requested-header]="phxVariant === 'requested'">
        <!-- <div *ngIf="phxVariant === 'requested'" class="phx-modal-upsell-success-icon"> -->
          <phx-modal-upsell-success-icon *ngIf="phxVariant === 'requested'"></phx-modal-upsell-success-icon>
        <!-- </div> -->
        <ng-content select="[phx-modal-upsell-title]"></ng-content>
        <ng-content select="[phx-modal-upsell-description]"></ng-content>
      </div>

      <!-- OFFER-specific content -->
      <ng-container *ngIf="phxVariant === 'offer'">
        <div class="phx-modal-upsell-price-card">
          <div class="phx-modal-upsell-data">
            <ng-content select="[phx-modal-upsell-label]"></ng-content>
            <ng-content select="[phx-modal-upsell-prices]"></ng-content>
            <ng-content select="[phx-modal-upsell-price-period]"></ng-content>
          </div>
        </div>

        <ng-content select="[phx-modal-upsell-disclaimer]"></ng-content>
      </ng-container>

      <!-- REQUESTED-specific content -->
      <ng-container *ngIf="phxVariant === 'requested'">
        <ng-content select="[phx-modal-upsell-requested-description]"></ng-content>
        <div class="phx-modal-upsell-contact">
          <ng-content select="[phx-modal-upsell-contact-text]"></ng-content>
          <ng-content select="[phx-modal-upsell-contact-info]"></ng-content>
        </div>
      </ng-container>

    </div>

    <!-- SHARED FOOTER -->
    <div class="phx-modal-upsell-footer">
      <ng-content select="[phx-modal-upsell-footer]"></ng-content>
    </div>

  </div>
</phx-dialog>
